<template>
    <div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-md-dhk">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="modal-title w-100">
                        <h2 class="mt-0 title--1">
                            Are you sure to delete {{ single_object.name }}?
                        </h2>
                        <h3 class="subtitle--1">
                            Confirmation
                        </h3>
                    </div>
                    <div class="modal__description">
                        <p class="modal__description__text my-3"> 
                        </p>
                    </div>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                      <img width="15px" src="/assets/img/svg/close.svg" alt="Imagen de una equis">
                    </button>
                </div>
                <div class="modal__buttons mt-0 text-center text-md-right">
                    <button type="button" data-dismiss="modal" class="modal__buttons__item cancel">Cancel</button>
                    <button type="button" class="modal__buttons__item" @click="event_emition()">Yes</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {

    name:   'DeletionModal',

    props: {
        global_index: {
            type: Number,
            default: 0
        },

        single_object: Object,
        
        id: {
            type: String,
            default: 'static-deletion'
        },

        local: {
            type: Boolean,
            default: false
        }
    },

    methods:{

        event_emition()
        {
            let object_emition = {
                id:     this.single_object.id,
                index:  this.global_index,
            }

            if(this.local)
            {
                this.$emit('objectDeletionLocal', object_emition);
            }
            
            else
            {
                this.$emit('objectDeletion', object_emition);
            }
        }
    },

    mounted(){

    }
}
</script>